import { render } from "./google-rating-badge.vue?vue&type=template&id=265bcc0d&scoped=true"
import script from "./google-rating-badge.vue?vue&type=script&lang=js"
export * from "./google-rating-badge.vue?vue&type=script&lang=js"

import "./google-rating-badge.vue?vue&type=style&index=0&id=265bcc0d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265bcc0d"]])

export default __exports__